(ns practitest.frontend.xbot.agents-view.views
  (:require
    [re-frame.core :as re-frame]
    [reagent.core :as r]
    ["react-modal" :as ReactModal]
    [practitest.frontend.xbot.subs :as subs]
    [practitest.frontend.common.ui :as ui]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.xbot.agents-view.av-agent-details :as av-ad]
    [practitest.frontend.xbot.agents-view.av-utilization-charts :as av-uc]
    [practitest.frontend.xbot.agents-view.av-availability-status :as av-as]
    [practitest.frontend.xbot.agents-view.av-common :as av-common]
    [practitest.frontend.xbot.agents-view.av-buttons :as av-btns]))

(defn display-status [{:keys [online? busy? enabled?]}]
  [:div.pull-left.agent-status
   "Agent Status: "
   [:label
    {:style {:color (if online?
                      "green"
                      "grey")}}
    [icons/circle-fill]
    (if online?
      " Online"
      " Offline")]
   (when (and online? (not enabled?)) " (Disabled)")])

(defn display-agent [agent id]
  (let [state (r/atom
               {:edit-client-id? false
                :show-log?       (:busy? agent)})]
    (fn [agent id]
      [:div.col-sm-12.col-md-12.col-lg-12.display-agent
       [:div.table-responsive.agent-box
        [:div;;.d-flex.justify-content-between
         {:style {:min-height "42px"}}
         [av-common/display-underline agent false true]
         [:div.d-flex.justify-content-between
          [display-status agent]
          [av-btns/display-disable-remove-btns agent id]]]
        [:table.table.table-condensed
         [:thead
          [:tr.table-body
           [:td.col-sm-6.col-md-4.col-lg-4.align-top.no-padding-sides.no-padding-top
            [av-common/display-underline agent]
            [av-ad/display-agent-details agent id state]]
           [:td.col-sm-6.col-md-8.col-lg-8.align-top.no-padding-sides.no-padding-top
            [av-common/display-underline agent]
            (if (< 996 js/window.innerWidth)
              [:div.d-flex.justify-content-between
               [av-uc/display-utilization-charts agent]
               [av-as/display-availability-status agent state]]
              [:div.d-flex.justify-content-between
               [av-as/display-availability-status agent state]
               [av-uc/display-utilization-charts agent]])]]]]
        [av-common/display-underline agent true]]])))

(defn backend-status []
  [:div.mt-2
   [:span.bold
    {:style {:font-size "18px"}}
    "xBot status: "]
   [:label
    {:style {:color (if @(re-frame/subscribe [::subs/connected?])
                      "green"
                      "red")}}
    (if @(re-frame/subscribe [::subs/connected?])
      "Online "
      "Offline ")
    [icons/circle-fill]]])

(defn display-show-offline [state]
  [:div
   [ui/eye-show-hide state :show-offline? "View offline agents"]])

(defn display-agents [state]
  (fn []
    [:div
     (let [agents (re-frame/subscribe [::subs/agents])]
       [:div
        (doall
         (for [[id agent] @agents
               :when      (or (:show-offline? @state)
                              (:online? agent))]
           ^{:key id} [display-agent agent id]))])]))

(defn account-agents-view []
  (let [state (r/atom {:show-offline? true})]
    [:div.d-flex.flex-column
     [:div.d-flex.justify-content-between
      [backend-status]
      [display-show-offline state]]
     [display-agents state]]))

;;(ReactModal/setAppElement "#app")
